import React from 'react';
import { RoleService } from 'Services';
import { shouldShowCompareSimulations } from 'Selectors';
import RouteLoading from 'Components/RouteLoading';
import useGetSimulations from 'Hooks/query-hooks/simulations/useGetSimulations';
import useGetReduxUsers from 'Hooks/reduxHelperHooks/useGetReduxUsers';
import useGetSimulationColumns from './useGetSimulationColumns';
import Table from './SimulationsTable';

const SimulationsTable = () => {
    const { users } = useGetReduxUsers();
    const simulations = useGetSimulations(users);
    const columns = useGetSimulationColumns();
    const rawData = !simulations.isError && simulations.data ? simulations.data : [];

    if (simulations.isInitialLoading) {
        return <RouteLoading />;
    }

    return (
        <Table
            rawData={rawData}
            rawColumns={columns}
            hideKebabMenuCol={!RoleService.hasEditRuleOrBulkUploadAccess}
            hideCompareCol={!shouldShowCompareSimulations()}
        />
    );
};

export default React.memo(SimulationsTable);
